import React, { useEffect, useState } from 'react';

import styles from './Textarea.module.css';

interface TextareaProps {
  content?: string | null;
  onChange?: (newValue: string) => void;
}

const Textarea: React.FunctionComponent<TextareaProps> = ({ content, onChange }) => {
  const [value, setValue] = useState<string | null | undefined>(content);

  const valueChanged = (element: React.ChangeEvent<HTMLTextAreaElement>) => {
    const newContent = element.target.value;
    setValue(newContent);
    onChange && onChange(newContent);
  };

  useEffect(() => setValue(content), [content]);

  const placeholder = 'Tell us here (optional)';

  return (
    <textarea
      className={styles.textareaIn}
      onChange={valueChanged}
      placeholder={placeholder}
      value={value || ''}
      data-testid="question-text-area"
    />
  );
};

Textarea.displayName = 'Textarea';

export default Textarea;
